import React from "react";

import HomePage from "./pages/HomePage";

import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import FindPasswordPage from "./pages/FindPasswordPage";

import { Navigate, Outlet } from "react-router-dom";
import PrivateRoute from "./utils/PrivateRoute";
import AuthRoute from "./utils/AuthRoute";

import Main from "./components/main/Main";

import DoctorList from "./components/doctorManagement/DoctorList";
import Schedule from "./components/doctorManagement/Schedule";
import PaidLeave from "./components/doctorManagement/PaidLeave";
import DoctorByReservation from "./components/reservation/DoctorByReservation";
import Reservation from "./components/reservation/Reservation";

import MaunalTheraistReservation from "./components/maunalTheraistReservation/MaunalTheraistReservation";
import MaunalTheraistByReservation from "./components/maunalTheraistReservation/MaunalTheraistByReservation";
import PrivacyPolicy from "./components/privacyPolicy/PrivacyPolicy";
import PrivacyRetention from "./components/privacyPolicy/PrivacyRetention";
import UserList from "./components/userManagement/UserList";
import MainTwo from "./components/mainTwo/MainTwo";
import MainThree from "./components/MainThree/MainThree";
import MaunalTheraistList from "./components/maunalTheraistManagement/MaunalTheraistList";
import MaunalTheraistSchedule from "./components/maunalTheraistManagement/MaunalTheraistSchedule";
import MaunalTheraistPaidLeave from "./components/maunalTheraistManagement/MaunalTheraistPaidLeave";
import AppUserList from "./components/appUserManagement/AppUserList";

const Router = [
  {
    path: "/",
    element: (
      <PrivateRoute>
        <AuthRoute>
          <HomePage />
        </AuthRoute>
      </PrivateRoute>
    ),
    children: [
      { path: "", exact: true, element: <Main /> },
      { path: "/dashboard", exact: true, element: <Main /> },
      { path: "/dashboard-2", exact: true, element: <MainTwo /> },
      { path: "/dashboard-3", exact: true, element: <MainThree /> },
      { path: "/doctorList", exact: true, element: <DoctorList /> },
      { path: "/doctor/schedule", exact: true, element: <Schedule /> },
      { path: "/doctor/paidLeave", exact: true, element: <PaidLeave /> },

      {
        path: "/maunalTheraistList",
        exact: true,
        element: <MaunalTheraistList />,
      },
      {
        path: "/maunalTheraist/schedule",
        exact: true,
        element: <MaunalTheraistSchedule />,
      },
      {
        path: "/maunalTheraist/paidLeave",
        exact: true,
        element: <MaunalTheraistPaidLeave />,
      },

      { path: "/reservation", exact: true, element: <Reservation /> },
      {
        path: "/doctorByReservation",
        exact: true,
        element: <DoctorByReservation />,
      },

      {
        path: "/maunalTheraistReservation",
        exact: true,
        element: <MaunalTheraistReservation />,
      },
      {
        path: "/maunalTheraistByReservation",
        exact: true,
        element: <MaunalTheraistByReservation />,
      },
      {
        path: "/userManagement",
        exact: true,
        element: <UserList />,
      },
      {
        path: "/appUserManagement",
        exact: true,
        element: <AppUserList />,
      },
    ],
  },
  {
    path: "/",
    element: (
      <>
        <Outlet />
      </>
    ),
    children: [
      { path: "/privacyRetention", element: <PrivacyRetention /> },
      { path: "/privacyPolicy", element: <PrivacyPolicy /> },
      { path: "/signin", element: <SignInPage /> },
      { path: "/signup", element: <SignUpPage /> },
      { path: "/find_password", element: <FindPasswordPage /> },
      { path: "*", element: <Navigate to="" replace={true} /> },
    ],
  },
];

export default Router;
